module.exports = __webpack_public_path__ + "img/medal1.bf2989e7.png";